"use strict";

import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { useRef, useState } from 'react';
import { AlertCircleIcon } from '@autoguru/icons';
import { Box, Icon, Inline, MinimalModal, Section, Text, useTextStyles } from '@autoguru/overdrive';
import clsx from 'clsx';
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
//@ts-ignore
export const SupportedBrowsersBoundary = _ref => {
  let {
    children,
    errorFallback,
    browsers,
    errorMessage = 'Your browser is out of date and might not support all the features of this app.'
  } = _ref;
  const isSupported = useRef(browsers.test(navigator.userAgent));
  const [showStats, setShowStats] = useState(!isSupported.current);
  return isSupported.current ? /*#__PURE__*/_jsx(_Fragment, {
    children: children
  }) : errorFallback ? errorFallback : /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MinimalModal, {
      hideBackdrop: true,
      onRequestClose: () => setShowStats(false),
      isOpen: showStats,
      children: /*#__PURE__*/_jsx(Box, {
        width: "full",
        padding: "3",
        backgroundColour: "white",
        borderRadius: "md",
        children: /*#__PURE__*/_jsx(Section, {
          width: "small",
          children: /*#__PURE__*/_jsxs(Inline, {
            noWrap: true,
            space: "3",
            children: [/*#__PURE__*/_jsx(Icon, {
              className: clsx(useTextStyles({
                colour: 'warning'
              })),
              size: "large",
              icon: AlertCircleIcon
            }), /*#__PURE__*/_jsx(Text, {
              size: "3",
              children: errorMessage
            })]
          })
        })
      })
    }), children]
  });
};